import { asyncAction } from '@/lib/action';

export const getCategoriesAction = asyncAction('CATEGORIES/GET');
